import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import MapPage from './pages/MapPage';
import VerifyEmail from './pages/VerifyEmail';
import LoginOTP from './pages/LoginOTP';
import Dashboard from './pages/Dashboard';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<MapPage />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/login-otp" element={<LoginOTP />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute requireSubscription={true}>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
